export enum VARIANTS {
  ORDINARY = 'ordinary',
  REDUCED = 'reduced',
  YOUTH = 'youth',
  CHILD = 'child',
}

export type keyVariants = `${VARIANTS}`

export enum TYPE_MEMBERSHIP {
  ORDINARY = 'ordinary',
  REDUCED = 'reduced',
  YOUTH = 'youth',
  CHILD = 'child',
}

export type keyTypeMembership = `${TYPE_MEMBERSHIP}`
